import client from './client';

export const usersApi = {
  createAdmin(data) {
    return client.post('/users/admins', data);
  },
  getAdmins() {
    return client.get('/users/admins');
  },
};
